<div class="container">
  <div class="content">
    <h3>{{ errorMsg }}</h3>
    <h3>
      Preview from <i>{{ fileUrl }} </i>!
    </h3>

    <div class="previewImages" *ngIf="fileType.includes('image')">
      <img src="{{ imageUrl }}" />
    </div>

    <div class="previewText" *ngIf="fileType.includes('text')">
      <markdown
        [data]="textFileContent"
        style="white-space: pre-wrap"
      ></markdown>
    </div>
    <mat-progress-bar
      *ngIf="this.loading"
      mode="indeterminate"
    ></mat-progress-bar>
    <h3 *ngIf="!isWriteable && !loading" style="color: #0074d9">
      You can not edit this file.
    </h3>
    <br />
    <button
      *ngIf="!this.loading"
      class="editor-button"
      mat-raised-button
      color="primary"
      [routerLink]="['/files']"
    >
      Back to files
    </button>
    <button
      class="editor-button"
      mat-raised-button
      color="accent"
      *ngIf="fileType.includes('text') && isWriteable"
      (click)="this.open(fileUrl)"
    >
      Open in editor
    </button>
  </div>
</div>
